import React from "react";
import { CheckCircle2, Clock, Loader2, AlertTriangle } from "lucide-react";

const MAP = {
  registered: {
    label: "Registered",
    cls: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
    Icon: CheckCircle2,
    spin: false,
  },
  in_progress: {
    label: "In Progress",
    cls: "bg-blue-500/10 text-blue-400 border-blue-500/30",
    Icon: Loader2,
    spin: true,
  },
  pending: {
    label: "Pending",
    cls: "bg-amber-500/10 text-amber-400 border-amber-500/30",
    Icon: Clock,
    spin: false,
  },
  failed: {
    label: "Failed",
    cls: "bg-rose-500/10 text-rose-400 border-rose-500/30",
    Icon: AlertTriangle,
    spin: false,
  },
  needs_review: {
    label: "Needs Review",
    cls: "bg-amber-500/10 text-amber-400 border-amber-500/30",
    Icon: AlertTriangle,
    spin: false,
  },
};

export default function StatusBadge({ status }) {
  const cfg = MAP[status] || MAP.pending;
  const { Icon } = cfg;
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold ${cfg.cls}`}
    >
      <Icon className={`h-3 w-3 ${cfg.spin ? "animate-spin" : ""}`} />
      {cfg.label}
    </span>
  );
}
